import { render } from "./ModalLeave.vue?vue&type=template&id=4801bcf5"
import script from "./ModalLeave.vue?vue&type=script&lang=js"
export * from "./ModalLeave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__